import { render, staticRenderFns } from "./add-custom-field-widget.vue?vue&type=template&id=c6bb80d0&"
import script from "./add-custom-field-widget.vue?vue&type=script&lang=js&"
export * from "./add-custom-field-widget.vue?vue&type=script&lang=js&"
import style0 from "./add-custom-field-widget.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports